import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'wz-wrapper-2',
  template: `
    <div class="card">
      <div class="card-body">
        <p>
          <strong
            >Nous vous rappelons que vous devez informer votre client de son
            droit d’être inscrit gratuitement sur la liste d’opposition au
            démarchage téléphonique (l'article L. 223-1 du code de la
            consommation).</strong
          >
          Il est interdit de démarcher par téléphone des consommateurs inscrits
          sur la liste Bloctel sauf en cas de « relations contractuelles
          préexistantes ». Il est possible de démarcher par téléphone des
          consommateurs inscrits sur la liste Bloctel que si vous répondez à une
          sollicitation formelle et éclairée de leur part ou s’il existe déjà un
          contrat en cours et que vous répondez à un besoin en rapport avec
          l’objet du contrat, y compris lorsqu’il s’agit de proposer au
          consommateur des produits ou des services afférents ou complémentaire
          à l’objet du dit contrat ou de nature à améliorer ses performances ou
          sa qualité.
        </p>
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
  standalone: false,
})
export class Wrapper2Component extends FieldWrapper {}
